import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbUsuarioCredencial extends AppService {
  abstract prefixo: string;
  abstract getAllDto(): Observable<any>;
  abstract vinculaCredencialPessoa(dto: any): Observable<any>;
  abstract desvinculaCredencialPessoa(credencialId: number): Observable<any>
  abstract getDtoByPessoaId(pessoaId: number): Observable<any>;
}